import React, { useState, useEffect, useCallback } from 'react';
import styles from './TestimonialSlider.module.css';
import { FaArrowLeft, FaArrowRight, FaChevronUp } from 'react-icons/fa';

const testimonialsData = [
  {
    id: 1,
    quote: "Digi Savvy has helped us from the very start — right from designing our logo to building our full brand concept. Their campaigns brought in quality leads that turned into real estate sales in just a few weeks. Thanks to their creative and smart work, EEM Developers now has a modern and trusted image. We highly recommend them to any builder wanting to grow.",
    author: "Director",
    company: "EEM Developers – Builders"
  },
  {
    id: 2,
    quote: "We’ve been working with Digi Savvy to improve our social media and generate leads — and the results have been great. They understand our business well and bring in good quality leads through their marketing. It’s been a smooth and professional experience working with them.",
    author: "CEO",
    company: "BBN Fincon Pvt Ltd – Finance Company"
  },
  {
    id: 3,
    quote: "Digi Savvy has helped us improve our company’s online presence and also worked on promoting our school based in Amritsar. They’ve been creative, responsive, and always ready to support our goals. We’ve seen clear results and better visibility because of their efforts.",
    author: "Founder",
    company: "The Wisdom Groups – Montessori Equipment, School IT & Construction Services"
  },
  {
    id: 4,
    quote: "We worked with Digi Savvy to promote our second home projects in Uttarakhand. Their campaigns reached the right people, and we got a great response from interested buyers. They understand how to present real estate in a way that connects with today’s audience.",
    author: "Managing Director",
    company: "Aita Group – Builders"
  },
  {
    id: 5,
    quote: "Digi Savvy has done a great job promoting our residential and commercial projects across Delhi NCR, Noida, and Dholera. Their campaigns brought in good leads, and they helped us get noticed in a crowded market. We’re happy with their support and results.",
    author: "CEO",
    company: "Sky Infra – Real Estate Company"
  },
  {
    id: 6,
    quote: "We wanted to increase admissions and build a strong name for our preschool and its franchise branches. Digi Savvy helped us do just that. Their creative work and focused campaigns made a big difference — more parents now know and trust Little Gopala.",
    author: "Principal",
    company: "Little Gopala Pre School – Educational Institution"
  }
];

function TestimonialSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [animationDirection, setAnimationDirection] = useState(''); // 'entering' or 'exiting'

  const handleNext = useCallback(() => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setAnimationDirection('exiting');

    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonialsData.length);
      setAnimationDirection('entering');
      setTimeout(() => {
        setIsTransitioning(false);
        setAnimationDirection('');
      }, 50); // Small delay to ensure 'entering' class applies for transition
    }, 400); // Corresponds to CSS transition duration
  }, [isTransitioning]);

  const handlePrev = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setAnimationDirection('exiting'); // You might want a different exit for prev

    setTimeout(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? testimonialsData.length - 1 : prevIndex - 1
      );
      setAnimationDirection('entering'); // You might want a different entry for prev
      setTimeout(() => {
        setIsTransitioning(false);
        setAnimationDirection('');
      }, 50);
    }, 400);
  };

  // Optional: Auto-slide
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     handleNext();
  //   }, 5000); // Change slide every 5 seconds
  //   return () => clearTimeout(timer);
  // }, [currentIndex, handleNext]); // Add handleNext to dependency array

  const currentTestimonial = testimonialsData[currentIndex];

  let cardClassName = styles.testimonialCard;
  if (isTransitioning && animationDirection === 'exiting') {
    cardClassName += ` ${styles.exiting}`;
  } else if (isTransitioning && animationDirection === 'entering') {
    cardClassName += ` ${styles.entering}`;
  }


  return (
    <div className={styles.testimonialSliderContainer}>
      <div className={styles.navigation}>
        <button
          onClick={handlePrev}
          className={styles.navButton}
          aria-label="Previous testimonial"
          // disabled={currentIndex === 0} // Optional: disable at start
        >
          <FaArrowLeft />
        </button>
        <button
          onClick={handleNext}
          className={styles.navButton}
          aria-label="Next testimonial"
          // disabled={currentIndex === testimonialsData.length - 1} // Optional: disable at end
        >
          <FaArrowRight />
        </button>
      </div>

      {/* Use key to force re-render for transition, or manage classes as done */}
      <div
        key={currentTestimonial.id} // Key helps React differentiate elements for animations
        className={cardClassName}
      >
        <span className={styles.quoteMark}>“</span>
        <div className={styles.testimonialContent}>
          <p className={styles.quoteText}>{currentTestimonial.quote}</p>
          <div className={styles.authorInfo}>
            <span className={styles.authorName}>{currentTestimonial.author}</span>
            {' / '}
            <span className={styles.authorRole}>{currentTestimonial.company}</span>
          </div>
        </div>
      </div>

     
    </div>
  );
}

export default TestimonialSlider;